module.exports = __webpack_public_path__ + "img/main-logo.5f5a29a4.png";